import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

/**
 * Returns a copy of the given object without any undefined or null values.
 */
export function omitNil<O extends Record<any, any>>(object: O): Partial<O> {
  // @ts-expect-error - TS2322 - Type 'Dictionary<any>' is not assignable to type 'Partial<O>'.
  return omitBy(object, isNil);
}

export function values<T>(ob: {[key: string]: T}): Array<T> {
  return Object.values(ob);
}

// @ts-expect-error - TS2344 - Type 'K' does not satisfy the constraint 'string | number | symbol'.
export function keys<K, V>(ob: Partial<Record<K, V>>): Array<K> {
  // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'K[]'.
  return Object.keys(ob);
}

// @ts-expect-error - TS2344 - Type 'K' does not satisfy the constraint 'string | number | symbol'.
export function entries<K, V>(ob: Partial<Record<K, V>>): Array<[K, V]> {
  // @ts-expect-error - TS2322 - Type '[string, any][]' is not assignable to type '[K, V][]'.
  return Object.entries(ob);
}

// TODO (kyle): we probably need to remove this. this function cannot be typed
// without inference and should not be exported.
/*
export function getProp<T: {...}>(object: T, propName: string) {
  return propName in object ? object[propName] : null;
}
*/
